import PropTypes from "prop-types";
import styles from "./StyleCount.css";
import { useLocale } from "../LocaleProvider";

const StyleCount = ({ itemCount }) => {
  const { formatTranslation, formatNumber } = useLocale();

  return (
    <p className={styles.styleCount}>
      {formatTranslation("plp_web_style_count_noun", {
        smart_count: itemCount,
        formattedCount: formatNumber(itemCount)
      })}
    </p>
  );
};

StyleCount.propTypes = {
  itemCount: PropTypes.number.isRequired
};

export default StyleCount;
